var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TServFilterHouseComp',{attrs:{"compProps":{fromDate: _vm.fromDate, toDate: _vm.toDate},"payLoad":_vm.payLoad,"compIndex":''},on:{"finish":_vm.finishHandle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }